import axios from 'axios'

export default  {
  namespaced: true,

  state: {},

  actions: {
    create({commit}, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('/portal-global/tags', params)
          .then(res => {
            resolve(res.data.data.datas)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
  },
}
